import { warn } from '@execonline-inc/logging';
import { assertNever } from '@kofno/piper';
import { HttpError } from 'ajaxian';
import { Task } from 'taskarian';
import {
  AppyError,
  MissingApiCompatibility,
  MissingApplicationId,
  callApi,
} from '../../../../../../Appy';
import ErrorActionableReaction, {
  EAProps,
  handleError,
} from '../../../../../../ErrorActionableReaction';
import { MissingLinkError, findLinkT } from '../../../../../../LinkyLinky';
import { Link } from '../../../../../../Resource/Types';
import ReclaimLicensesStore from '../Store';
import { State } from '../Types';
import { bulkLicensesReclaimedResourceDecoder } from './Decoder';

interface Props extends EAProps<ReclaimLicensesStore> {}

type ReclaimLicensesError =
  | HttpError
  | MissingLinkError
  | MissingApplicationId
  | MissingApiCompatibility
  | AppyError;

interface GroupMembershipsOut {
  reclaim_licenses: {
    user_ids: number[];
  };
}

export const reclaimLicensesEncoder = (store: ReclaimLicensesStore): GroupMembershipsOut => ({
  reclaim_licenses: {
    user_ids: store.participantsStore.checkedParticipants.map(
      (participantStore) => participantStore.resource.payload.id,
    ),
  },
});

const reclaimLicensesError = (store: ReclaimLicensesStore) => (error: ReclaimLicensesError) => {
  switch (error.kind) {
    case 'bad-status':
    case 'missing-link-error':
      store.error('We are unable to process your request at this time');
      warn('ReclaimLicensesReactions', error.kind, error);
      break;
    default:
      handleError(store, error);
  }
};

class ReclaimLicensesReactions extends ErrorActionableReaction<ReclaimLicensesStore, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'updating':
        Task.succeed<ReclaimLicensesError, ReadonlyArray<Link>>(store.participantsStore.links)
          .andThen(findLinkT('bulk-reclaim-license'))
          .andThen(callApi(bulkLicensesReclaimedResourceDecoder, reclaimLicensesEncoder(store)))
          .fork(reclaimLicensesError(store), store.succeeded);
        break;
      case 'ready':
      case 'succeeded':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default ReclaimLicensesReactions;
